import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    responsesTreeStructureNodeData: []
}

const ResponsesTreeStructureSlice = createSlice({
  name: 'responseTreeStructure',
  initialState,
  reducers: {
    setResponsesTreeStructureNodeData: (state, action) => {
      state.responsesTreeStructureNodeData = action.payload
    }
  }
})

export const { setResponsesTreeStructureNodeData } = ResponsesTreeStructureSlice.actions

export default ResponsesTreeStructureSlice.reducer